enum PosicaoRotulo {
    Nenhuma = 0,
    Esquerda = 1,
    Direita = 2,
    Cima = 3,
    Baixo = 4,
}

export default PosicaoRotulo;
